import { render, staticRenderFns } from "./fourImgHorPre.vue?vue&type=template&id=f9155d2a&scoped=true&"
import script from "./fourImgHorPre.vue?vue&type=script&lang=js&"
export * from "./fourImgHorPre.vue?vue&type=script&lang=js&"
import style0 from "./fourImgHorPre.vue?vue&type=style&index=0&id=f9155d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9155d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9155d2a')) {
      api.createRecord('f9155d2a', component.options)
    } else {
      api.reload('f9155d2a', component.options)
    }
    module.hot.accept("./fourImgHorPre.vue?vue&type=template&id=f9155d2a&scoped=true&", function () {
      api.rerender('f9155d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subject/preview/fourImgHorPre.vue"
export default component.exports